import React from 'react';
import { Link } from 'react-router-dom';

import Image from '../../assets/img/work/work-1.svg';

const SingleWork = (props) => {
  const { itemClass, iconImage, iconClass, title, description, to } = props;
  return (
    <div className={itemClass ? itemClass : 'it-work-item text-center'}>
      <div className="it-work-icon">
        <span>
          {iconClass ? (
            <i className={iconClass}></i>
          ) : (
            <img src={iconImage ? iconImage : Image} alt="" />
          )}
        </span>
      </div>
      <div className="it-work-content">
        <h4 className="it-work-title-sm">
          <Link to={to ? to : '/programs'}>{title ? title : 'Choose A Program'}</Link>
        </h4>
        <p>
          {description
            ? description
            : ''}
        </p>
      </div>
    </div>
  );
};
export default SingleWork;
